import React from "react";
import { T } from "services/lang/LanguageService";
import { useHasPermissions } from "hooks/useHasPermissions";
import EasasPageTemplateWrapper from "../../templates/EasasPageTemplateWrapper";

export default function AuthorizationManagementPage() {
  const isAllowed = useHasPermissions("ADMIN");

  return (
    <EasasPageTemplateWrapper
      breadcrumb={["Authorization management"]}
      title="Authorization management"
      cardStyle={{ height: "100%" }}
    >
      {isAllowed && (
        <div>
          <h1>{T("label.authorization-management.authorization-management")}</h1>
        </div>
      )}
      {!isAllowed && (
        <div>
          <h1>{T("label.authorization-management.unauthorized")}</h1>
        </div>
      )}
    </EasasPageTemplateWrapper>
  );
}
